import { FormEvent, useContext, useState } from "react";

import { ProjectStatusConstants } from "../../../../constants";
import { ProjectContext } from "../../../../route/shared/projects/project/ProjectContext";
import { updateProjectStatus } from "../../../../service/project";
import { ServiceError, Status } from "../../../../service/Shared";
import { useIsLoadingWrapper } from "../../../../utils";
import { Toast } from "../../../../widget";

interface UseCancelProjectModalReturnData {
  errors: ServiceError[] | undefined;
  isHandleSubmitLoading: boolean;
  resetForm: () => void;
  handleSubmit: (e: FormEvent<HTMLFormElement>) => Promise<void>;
}

interface UseCancelProjectModalProps {
  closeModal: () => void;
  refreshProject: () => void;
}

export const useCancelProjectModal = ({
  closeModal,
  refreshProject,
}: UseCancelProjectModalProps): UseCancelProjectModalReturnData => {
  const { projectDetails, setProjectDetails } = useContext(ProjectContext);

  const [errors, setErrors] = useState<ServiceError[] | undefined>();
  const [isHandleSubmitLoading, setIsHandleSubmitLoading] = useState(false);

  const resetForm = (): void => {
    setErrors([]);
  };

  const handleSubmit = useIsLoadingWrapper(async (e: FormEvent<HTMLFormElement>): Promise<void> => {
    e.preventDefault();

    if (!projectDetails?.uuid && !projectDetails?.rowVersion) return;

    const res = await updateProjectStatus({
      projectUuid: projectDetails?.uuid,
      rowVersion: projectDetails?.rowVersion,
      status: ProjectStatusConstants.CANCELLED,
    });

    if (res.status === Status.Success && res.data) {
      Toast.success({ message: "Project cancelled successfully" });

      if (projectDetails) {
        setProjectDetails({
          ...projectDetails,
          status: ProjectStatusConstants.CANCELLED,
          rowVersion: res.data.rowVersion,
        });
      }

      refreshProject();
      resetForm();
      closeModal();
    }

    if (res.status === Status.Error) {
      setErrors(res.errors);
    }
  }, setIsHandleSubmitLoading);

  return {
    errors,
    isHandleSubmitLoading,
    resetForm,
    handleSubmit,
  };
};
